export default __webpack_public_path__ + "static/media/element-benefits.3c47f1af.svg";